<template>
    <v-container>
        <v-card>
            <v-card-title>
                Alarmas
                <!-- Botón reset de alarmas -->
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="resetAlarmas()">
                    Reset alarmas
                </v-btn>
            </v-card-title>

            <!-- Alarmas activas actualmente -->
            <v-container>
                <v-card v-if="alarmas_activas">

                    <!-- Título de alarmas activas -->
                    <v-card-title>
                        Actualmente activas
                    </v-card-title>

                    <!-- Tabla alarmas activas -->
                    <v-data-table :headers="headers_activas" :items="items_activas"
                        :footer-props="{
                            'items-per-page-text':'Alarmas por página'
                        }">
                    </v-data-table>
                </v-card>
                <v-card v-else>
                    <v-card-title>
                        Actualmente no se encuentra ninguna alarma activa
                    </v-card-title>
                </v-card>
            </v-container>

            <!-- Históricos de alarmas -->
            <v-container>
                <v-card>
                    <v-card-title>Históricos</v-card-title>
                    
                    <!-- Buscador -->
                    <v-text-field v-model="search" class="ml-4 mr-4 mb-4" append-icon="mdi-magnify" label="Buscar" single-line
                        hide-details></v-text-field>

                    <!-- Tabla de alarmas -->
                    <v-data-table :headers="headers" :items="items_historicos" :search="search"
                        :loading="loading_historicos"
                        :footer-props="{
                            'items-per-page-text':'Alarmas por página'
                        }"
                        >
                    </v-data-table>
                </v-card>
            </v-container>
        </v-card>

    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
    data() {
        return {
            search: null,
            loading_historicos: true,
            headers: [
                { text: "Fecha", value: "fecha_alarma" },
                { text: "Nombre", value: "nombre" },
                // { text: "Variable", value: "variable" },
            ],
            headers_activas: [
                // { text: "ID", value: "id" },
                { text: "Nombre", value: "nombre" },
                // { text: "Estado actual", value: "estado" },
            ],
            items_historicos: [],
            items_activas: [],
            alarmas_activas: false,
        };
    },
    computed: {
        ...mapState('nodered',['client']),
    },
    async created() {
        const alarms = await this.getHistoricosAlarmas();
        this.loading_historicos = false;
        this.items_historicos = alarms.data.results;
        this.items_historicos.forEach(e => e.fecha_alarma = moment(e.created_at).format('YYYY-MM-DD HH:mm:ss'))
        
        this.listenToTopicAlarm()
    },

    methods: {
        ...mapActions('api', ['getHistoricosAlarmas']),
        ...mapActions('nodered',['doSubscribe','doPublish']),
        listenToTopicAlarm(){
            //Obtener todas las alarmas con sus id-s para extraer los nombres
            //Subscribirme a alarmas_front
            this.doSubscribe('alarmas_front')

            this.client.on("message", (topic, message) => {
                if(topic=='alarmas_front'){
                    const mensaje = message.toString()
                    const parsed_mensaje = JSON.parse(mensaje)
                    this.items_activas=parsed_mensaje;
                    
                    //Actualizar si hay alarma activa o no
                    if(this.items_activas.length > 0) this.alarmas_activas = true
                    else this.alarmas_activas = false
                }
            })
        },
        resetAlarmas(){
            const payload = `{"timestamp": ${Date.now()}, "variable": "CIO1100.0", "valor":[1]}`
            const topic = `PLC1_write`
            //Mandamos má de una vez para aseguranos de que llega (cosas de charli)
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
            this.doPublish({topic, mensaje: payload})
        },
    }
}
</script>